import { getEndpoint, ENDPOINT_FORDELINGSTAL, ENDPOINT_FORDELINGSTAL_ACCUMULATED } from '../../services/service-some-api';
import {  externalTooltipHandlerFordelingstal } from './custom-tooltip';
import { ChartColors } from '../../consts/const-utils';
import { getRootVariable, setGlobalChartConfig } from '../../services/service-utils';
import { setChartScaleTitle, updateSalaryLegendStyle } from './chartjs-const';
import { EventBus, EventTypes } from '../../consts/const-event-types';


export default class ChartJSLineComponent {
  constructor(element) {
    this.el = element
  
    // Variables and config
    this.ctx = this.el.querySelector('.chart-canvas').getContext('2d');
    this.myChart = null;

    this.salaryGroup = "Standard";

    this.choicesContainer = this.el.querySelector("[choices-container]"); 
    this.placeholder = this.el.querySelector("[data-placeholder]"); 

 

    this.selectedChoices = [];
    this.choicesListSelected = null;
    this.usedColors = [];
    
    this.datasets = [];
    this.dataAccumulatedStats = null;
  

    // Bindings
    this.loadData = this.loadData.bind(this);
    this.loadAccumulatedTooltipData = this.loadAccumulatedTooltipData.bind(this);
    this.setupChart = this.setupChart.bind(this);
    this.externalTooltipHandlerWrapper = this.externalTooltipHandlerWrapper.bind(this);
    this.renderDropdown = this.renderDropdown.bind(this);
    this.removeSelectedChoice = this.removeSelectedChoice.bind(this);
    this.putBackToDropdown = this.putBackToDropdown.bind(this);
    this.putItemIntoSelectedContainer = this.putItemIntoSelectedContainer.bind(this);
    this.toggleChoicesDropdown = this.toggleChoicesDropdown.bind(this);
    
  
    // Functions
    this.init()
  }



  init()
  { 
    this.loadData();

    this.setupGlobalEvents();

    this.loadAccumulatedTooltipData();

  }


  setupGlobalEvents()
  {

    EventBus.addEventListener(EventTypes.SALARY_LEGEND_UPDATE, event => 
    {
      const { 
        chartElement,
        salaryGroup 
      } = event.detail;


      // We update the salary legend on every chart that has the salary legend, whenever we click on it
      // This below updates the salary "selected" state on any other salary legend than the one you click on
      if(chartElement.getAttribute("data-component") != this.el.getAttribute("data-component"))
      {
        updateSalaryLegendStyle(this.el, salaryGroup);
      }

      this.salaryGroup = salaryGroup;
      this.setupDatasets();
      this.setupChart();
      
    });

  }

  setupChart()
  {
    if(this.myChart){
      this.myChart.destroy();
    }

    // Add data and remove data

    if(this.ctx)
    {
      // Global config
      setGlobalChartConfig();
  
      this.myChart = new Chart(this.ctx, 
        {
        type: 'line',
        data: 
        {
          datasets: this.datasets,
        },
        options: 
        {
            responsive: true,
            maintainAspectRatio: false,
            tension: 0.05,
            indexAxis: 'x',  
            interaction: {
              intersect: false,
              mode: 'nearest',
            },
            layout: {
              
            },
            scales:
            {
              x:{
                title: setChartScaleTitle(),
                ticks: {
                  grace: "5%",  
                  callback: function(value)
                  {
                    return `${this.getLabelForValue(value)}`;
                  },
                  autoSkip: true,
                  autoSkipPadding: 140, 
                  maxRotation: 0,
                  major: {
                    enabled: true
                  }
                },
                grid: {
                  display: false,
                  offset: true
                },              
              },
              y:{
                min: 0,       
                ticks: {
                  mirror: false,
                  color: getRootVariable('--color-dark-gray'),             
                  padding: 10,
                  labelOffset: 0,
                  callback: function (value) {             
                    return `${this.getLabelForValue(value)}`;
                  },   
                },
                grid: {
                  offset: false, // If true, the bars for a particular data point fall between the grid lines.
                  display: true, 
                  drawBorder: false
                }
              },
              y2: {
                min: 0,
                position: "right",
                grid: {
                  offset: false, // If true, the bars for a particular data point fall between the grid lines.
                  display: false,
                  drawBorder: false
                }
              }
             
            },
            plugins: {
              legend: {
                display: false,
              },
              tooltip: {
                enabled: false,    
                external: this.externalTooltipHandlerWrapper,
              },
            }
        }
      });


      this.selectedChoices.length > 0 ? this.setXAxisSpan() : null;

      // Set same Y scale values
      this.myChart.options.scales.y.max = this.selectedChoices.length > 0 ? this.getHighestYValue() : 10;
      this.myChart.options.scales.y2.max = this.myChart.options.scales.y.max; 
      this.myChart.update();

      // Render Dropdown
      const labelsForDropdown = this.datasets.map(p => {
        return {
          label: p.label,
          color: p.borderColor
        }
      });

      this.renderDropdown(labelsForDropdown);
    }
  }

  


  renderDropdown(labels)
  {
    const template = 
     `
      <div class="choices-list-selected" data-choices-list-toggle>
        <div class="selected-choices-container" data-selected-choices-container></div>
        <div class="icon-dropdown">
          <svg width="10" height="6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m5 6 5-6H0l5 6Z" fill="currentColor"/></svg>
        </div>
      </div>
      <div class="choices-list" choices-list>
        <ul>
        ${labels.map(l => `<li data-value="${l.label}" data-color="${l.color}">${l.label}</li>`).join('')}
        </ul>
      </div>
    `;

    this.choicesContainer.innerHTML = template;


    this.choicesList =  this.choicesContainer.querySelector("[choices-list]");

    // Toggler
    this.choicesListSelected =  this.choicesContainer.querySelector("[data-choices-list-toggle]");
    this.choicesListSelected && this.choicesListSelected.addEventListener("click", (evt) => 
    {
      // Only toggle if you dont press a data-value
      if(!evt.target.getAttribute("data-value"))
      {
        this.toggleChoicesDropdown(evt);
      }
    })

    this.selectedChoicesContainer = this.choicesContainer.querySelector("[data-selected-choices-container]");

    // Click for dropdown when adding to the selected list
    this.choicesDropdown =  this.choicesList.querySelectorAll("li[data-value]");
    this.choicesDropdown && this.choicesDropdown.forEach(c => 
    {
      c.removeEventListener("click", this.putItemIntoSelectedContainer);
      c.addEventListener("click", this.putItemIntoSelectedContainer)
    });


    // Render start template
    this.renderSelectedChoices();
  }

  putItemIntoSelectedContainer(evt)
  {
    const item = evt.target;
    const value = item.getAttribute("data-value");


    if(ChartColors.length == this.usedColors.length)
    {
      this.usedColors = [];
    }

    var colorChoice;

    ChartColors.forEach(color => 
    {
      var isColorUsed = this.isColorAlreadyUsed(color);

      if(!isColorUsed && !colorChoice)
      {
        colorChoice = color;

        this.usedColors.push(color);
      }
    })

   

    item.classList.add("chosen");

    this.selectedChoices.push(
    { 
      value: value, 
      color: colorChoice 
    });

    this.renderSelectedChoices();

    this.toggleDatasetVisibility(value, "add", colorChoice);
  }

  putBackToDropdown(evt)
  {
    const item = evt.target;
    const value = item.getAttribute("data-value");

    // remove from selected choice
    this.removeSelectedChoice(value);

    // Remove li
    item.remove();

    // show again in dropdown list
    var selectedDropdownItem = this.choicesList.querySelector(`[data-value='${value}']`);
    if(selectedDropdownItem) 
    {
      selectedDropdownItem.classList.remove("chosen");
    }

    this.toggleDatasetVisibility(value, "remove");    
  }

  isColorAlreadyUsed(selectedColor)
  {
    var found = false;

    this.usedColors.forEach(usedColor => {
      if(usedColor == selectedColor)
      {
        found = true;
      }
    })

    return found;
  }

  getHighestYValue()
  {
    var y = 0;

    this.myChart.data.datasets.forEach((dataset) => 
    {
      if(dataset.hidden == false)
      {
        const highestY = Math.max(...dataset.data.map(d => d.y));

        if(y < highestY)
        {
          y = highestY;
        }
      }
    });

    // Buffer on top
    y = Math.round(y + 2);

    

    return y;
  } 

  toggleDatasetVisibility(value, type, color)
  {
    const isHidden = type === "add" ? false : true;

    this.myChart.data.datasets.forEach(dataset => 
    {
      if(dataset.label === value)
      {
        dataset.hidden = isHidden;    

        if(color)
        {
          dataset.borderColor = color;
          dataset.pointBackgroundColor = color;
          dataset.pointBorderColor = color;
        }
      }
    });


    this.setXAxisSpan();
  

    this.myChart.options.scales.y.max = this.getHighestYValue();
    this.myChart.options.scales.y2.max = this.getHighestYValue();  
 
    this.myChart.update();

    // Toggle Placeholder
    this.selectedChoices.length > 0 ? this.placeholder.style.display = "none" :   this.placeholder.style.display = "flex";
  }

  setXAxisSpan()
  {
    // Get highest X value from visible dataset
    var highest = 0;
      
    this.myChart.data.datasets.forEach((dataset) => 
    {
      if(dataset.hidden == false)
      {
        dataset.data.forEach(d => 
        {
          if(d.y > 0 && d.x > highest)
          {
            highest = d.x;
          }          
        })
      }
    });

    // Add 20 buffer
    highest = highest + 20;

    var numberArray = [];

    for(var i = 115; i < highest;) 
    {      
      numberArray.push(i);
      i = i + 5;
    }

    this.myChart.data.labels = numberArray;
  }


  removeSelectedChoice(selectedValue)
  {
    var foundColor = this.selectedChoices.filter(s => s.value === selectedValue);

    const filteredArray = this.selectedChoices.filter((p) => { 
        return p.value  !=  selectedValue;
    });
    this.selectedChoices = filteredArray;

    // remove specific color from used colors
    if(foundColor)
    {
      const filteredColorArray = this.usedColors.filter(usedColor => { 
        return usedColor  != foundColor[0].color;
      }); 
      this.usedColors = filteredColorArray;
    }
  }


  renderSelectedChoices()
  {
    // Render list
    if(this.selectedChoices)
    {
      const template = 
      `<ul>
      <li class="placeholder">Klik for at tilføje personalegrupper</li>
      ${this.selectedChoices.map(s => `<li data-value="${s.value}" style="border-color: ${s.color}">${s.value}<span class="svg-close"><svg width="10" height="10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m1 8.75 7.5-7.5M8.5 8.75 1 1.25" stroke="#737373" stroke-width="2"/></svg></span></li>`).join('')}
      </ul>`;
 
     this.selectedChoicesContainer.innerHTML = template;


      // Attach event listeners to selected items
     const selectedChoices =  this.selectedChoicesContainer.querySelectorAll("li[data-value]");

     selectedChoices && selectedChoices.forEach(s => 
     {
       s.removeEventListener("click", this.putBackToDropdown);
       s.addEventListener("click", this.putBackToDropdown);
     })




    }
  }


  toggleChoicesDropdown(evt)
  {
    if(!evt.target.getAttribute("data-value"))
    {
      if(this.choicesContainer.classList.contains("open"))
      {
        this.choicesContainer.classList.remove("open");
  
        // Remove event listener
        document.body.removeEventListener("click", this.toggleChoicesDropdown);
      }
      else{
        this.choicesContainer.classList.add("open");
  
        // Allows you to click outside of the element and close the dropdown
        setTimeout(() => {
          document.body.addEventListener("click", this.toggleChoicesDropdown);
        }, 100);
      }
    }
  }
  
  setupDatasets()
  {
    var colorIndex = 0;
    this.datasets = [];
  
    this.data[this.salaryGroup].forEach(d => 
    {
      if(!ChartColors[colorIndex])
        colorIndex = 0;

      var dataset = {
        label: d["Group"],
        data: [],
        fill: false,
        pointStyle: 'circle',
        pointRadius: 0,
        pointHoverRadius: 5, 
        borderColor: ChartColors[colorIndex],
        pointBackgroundColor: ChartColors[colorIndex],
        pointBorderColor: ChartColors[colorIndex], 
        borderWidth: 3,
        hidden: true
      };

      // Check if some have already been preselected  
      this.selectedChoices.forEach(s => {
        if(s.value == d["Group"])
        {
          
          dataset.hidden = false;
          dataset.borderColor =  s.color;
          dataset.pointBackgroundColor =  s.color;
          dataset.pointBorderColor =  s.color;           
        }
      })


      if(d.Group)
      {
        dataset.label = d.Group;
      }

      Object.keys(d).forEach(k => 
      {
        if(k != "Group")
        {

          var yValue = parseFloat(d[k]);

          dataset.data.push({
            x: parseFloat(k),
            y: yValue
          })      
        }
      })

      // Add to general datasets array
      this.datasets.push(dataset);  

      colorIndex++;
    });
  } 

  
  externalTooltipHandlerWrapper(context)
  {
    externalTooltipHandlerFordelingstal(context, this.dataAccumulatedStats, this.salaryGroup);
  }

  async loadData()
  {
    this.data = await getEndpoint(ENDPOINT_FORDELINGSTAL);

    if(this.data)
    { 
      this.setupDatasets();
      this.setupChart();
    }
  }

  async loadAccumulatedTooltipData()
  {
    this.dataAccumulatedStats = await getEndpoint(ENDPOINT_FORDELINGSTAL_ACCUMULATED);
    
  }

}
